import React from 'react';
import Homepage from './Pages/Homepage/Homepage';
import './App.css';

const App = () => {
  return (
    <>
      <Homepage />
    </>
  );
}

export default App